import React, { Component } from "react";
import Cookies from "js-cookie";
import "./editCinImage.css";
import { ApiUrl } from "../../config";

class EditCinImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImage: null,
      cinType: props.cinType, // 'cinRecto' or 'cinVerso'
      isLoading: false,
      error: "",
    };
  }

  handleImageChange = (event) => {
    const file = event.target.files[0];  // Get the selected file from the input
    if (file) {
      this.setState({ selectedImage: file });  // Store the file in state
    }
  };
  
  handleSave = async () => {
    const { selectedImage } = this.state;
    const { token, onHide } = this.props; // Assuming citizenId is passed as a prop
    if (!selectedImage) {
      alert("Please select an image.");
      return;
    }

    // Create a FormData object to send the file
    const formData = new FormData();
    formData.append(this.props.cinType, selectedImage);

    if (token) {
      try {
        const response = await fetch(
          `${ApiUrl}citoyens/edit-cin-image`,
          {
            method: "POST",
            body: formData,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();

        console.log(data);

        if (response.ok) {
          this.setState({ isLoading: false });
          if (this.props.onSuccess) {
            this.props.onSuccess();
          }

          if (this.props.onAlert) {
            this.props.onAlert('Image de la CIN mise à jour avec succès !');
          }
          this.setState({ selectedImage: null });
          onHide();
        }  else {
          // Handle errors properly, check if it's an object or array
          if (data.errors) {
            // If errors is an object, convert it into a readable string
            const errorMessages = Object.values(data.errors).join(", ");
            this.setState({
              isLoading: false,
              error: errorMessages || "Something went wrong.",
            });
          } else {
            this.setState({
              isLoading: false,
              error: "Something went wrong.",
            });
          }
        }
      } catch (error) {
        console.error("Error:", error);
        this.setState({
          isLoading: false,
          error: "Network error. Please try again.",
        });
      }
    }
  };

  handleCancel = () => {
    // Reset the selected image when the "Annuler" button is clicked
    this.setState({ selectedImage: null });
    this.props.onHide(); // Close the modal

    this.setState({ 
      error: "" 
    });
  };



  render() {
    const { show, onHide, cinType } = this.props;
    const { selectedImage, isLoading, error } = this.state;

    if (!show) return null;

    return (
      <div
        className="modal show d-block"
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Modifier l'image - {cinType}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={this.handleCancel}
              ></button>
            </div>
            <div className="modal-body">
              {error && <div className="alert alert-danger mt-3">{error}</div>}
              <input
                type="file"
                accept="image/*"
                onChange={this.handleImageChange}
                className="form-control"
              />

              {selectedImage && (
                <div className="mt-3">
                  <img
                    src={URL.createObjectURL(selectedImage)} // Temporary image preview
                    alt="Preview"
                    style={{
                      width: "150px",
                      height: "auto",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      marginTop: "10px",
                    }}
                  />
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={this.handleCancel}
              >
                Annuler
              </button>
              <button
                className="btn btn-primary ml-3"
                onClick={this.handleSave}
                disabled={isLoading}
              >
                {isLoading ? "Enregistrement..." : "Enregistrer"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditCinImage;
